module.exports = __webpack_public_path__ + "static/media/jalapeno-lime-desktop-fr.e4db14b3.jpg";